<!-- rota: /tanimlamalar/sirket  (name: parametre-sirket) -->
<template>
  <!--
    Cerceve ve yetkilendirme TABANDAN geliyor: v-app, baslik cubugu,
    yetkidialog, snackbar ve yukleniyor gostergesi sayfataban.vue icinde.
    Burada yalnizca sayfanin kendi icerigi var.

    Sayfanin kendi v-card'i KORUNDU: tabaninki flat, yani ic ice golge
    olusmuyor; boylece sekmelerin mevcut gorunumu degismiyor.
  -->
  <sayfataban :baslik="$t('Corporate-Parameters')" :oncekiRota="oncekiRota" :durum="durum" ref="taban">

    <!-- Baslik cubugunun sagi. Bu slot KAPSAMLI DEGIL (tabanda
         slot name="baslikSag" kapsamsiz tanimli), yani kaydedebilir buradan
         okunamiyor; sayfa yetkiyi mounted'da tabandan alip kendi data'sina
         yaziyor. -->
    <template slot="baslikSag">
      <!-- color="" ZORUNLU: orijinal v-btn'de renk yoktu, bilesenin color
           varsayilani "primary"; verilmezse koyu baslik cubugunda buton
           maviye doner. flat varsayilani zaten true. -->
      <!-- v-if: Save yetkisi olmayana buton hic cizilmiyor (tabanin
           belgeledigi kalip). :disabled AYRI bir kapi: CompanyGet basariyla
           bitmeden kaydedilemez, cunku Kaydet butun SirketParametre
           nesnesini oldugu gibi POST ediyor ve yukleme basarisiz olursa nesne
           data()'daki bos iskelet olarak kalip firmanin gercek
           parametrelerini EZER. -->
      <kaydetbutonu v-if="kaydetYetkisi" :action="Kaydet" :disabled="!parametreYuklendi" color="">
        {{$t("save_button")}}
        <v-icon right dark>add_box</v-icon>
      </kaydetbutonu>
    </template>

    <v-form>
      <v-card color="grey lighten-5">
        <v-layout row wrap>
          <v-tabs style="width:100%; height:100%" dark="" v-model="active" color="blue darken-3" slot="extension"
            slider->
            <v-tabs-slider></v-tabs-slider>
            <v-tab href='#0'>
              {{$t("tab_general")}}
            </v-tab>
            <v-tab-item :id="'0'" style="width:100%; height:100%;">
              <v-layout row="" wrap="">
                <v-flex pa-1 xs12 sm12 md4>
                  <v-card>
                    <v-card color="grey lighten-5" flat="">
                      <v-card-actions>
                        <v-layout justify-space-between column>


                          <v-text-field hide-details="" v-model="SirketParametre.Il" label="İl"></v-text-field>
                          <v-text-field :label="$t('District')" hide-details="" v-model="SirketParametre.Ilce"></v-text-field>
                          <v-text-field mask="NNNNNNNNNNNNNNN" hide-details="" v-model="SirketParametre.Tel"
                            :label="$t('Phonenumber_label')">
                          </v-text-field>
                          <v-text-field mask="NNNNNNNNNNNNNNN" hide-details="" v-model="SirketParametre.Fax"
                            label="Fax">
                          </v-text-field>
                          <v-text-field hide-details="" v-model="SirketParametre.Email" :label="$t('Company-E-mail-Address')">
                          </v-text-field>
                          <v-textarea v-model="SirketParametre.Adres" hide-details :label="$t('Address_label')"></v-textarea>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>


                <v-flex pa-1 xs12 sm12 md4>
                  <v-card>
                    <v-card color="grey lighten-5" flat="">
                      <v-card-actions>

                        <v-layout justify-space-between column>

                          <v-text-field hide-details="" v-model="SirketParametre.VergiDairesi" :label="$t('Taxcenter_label')">
                          </v-text-field>
                          <v-text-field hide-details="" v-model="SirketParametre.VergiNo" :label="$t('Taxnumber_label')">
                          </v-text-field>
                          <v-text-field hide-details="" type="Number" v-model="SirketParametre.FaturaSatirAdedi"
                            :label="$t('Number-of-Rows-in-Invoice')" value=""></v-text-field>
                          <v-text-field v-if="PB=='TRY'" hide-details="" label="Ticaret Sicil No"
                            v-model="SirketParametre.TicaretSicilNo" value=""></v-text-field>

                          <parainput :simge="getparabirimi()" :etiket="$t('Cash-Turnover')" v-model="SirketParametre.KasaDevir"
                            :autocomplete="'autocomplete'"></parainput>

                          <v-text-field v-if="PB=='TRY'" hide-details="" v-model="SirketParametre.MersisNo" :label="$t('Central-Registration-No')">
                          </v-text-field>
                          <v-text-field hide-details="" v-model="SirketParametre.WebAdres" :label="$t('Company-Web-Address')">
                          </v-text-field>
                        </v-layout>

                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>

                <v-flex pa-1 xs12 sm12 md4>
                  <v-card>
                    <v-card color="grey lighten-5" flat="">
                      <v-card-actions>
                        <v-layout justify-space-between column>

                          <v-text-field v-if="PB=='TRY'" hide-details="" v-model="SirketParametre.SmsKod" :label="'SMS' + $t('Customer-Code')">
                          </v-text-field>
                          <v-text-field  v-if="PB=='TRY'" hide-details="" v-model="SirketParametre.SmsSifre" :label="$t('SMS-Password')">
                          </v-text-field>
                          <v-text-field hide-details="" v-model="SirketParametre.SerbestMail"
                            :label="$t('Free-Invoice-Mail-Design')">
                          </v-text-field>
                          <v-select v-if="PB=='TRY'" :items="doviztipi" clearable item-text="DovizAdi" item-value="DovizKod"
                            v-model="SirketParametre.DefaultCurrency" :label="$t('Default-Currency')"></v-select>
                          <v-select v-if="PB=='TRY'" :items="efaturatipi" hide-details="" item-text="text" item-value="value"
                            v-model="SirketParametre.VarsayilanEfaturaTip" :label="$t('E-invoicetype')" clearable="">
                          </v-select>
                          <v-select v-if="PB=='TRY'" :items="kurparametresi" clearable hide-details=""
                            v-model="SirketParametre.OpsiyonBilgileri.KurParametre" item-text="text" item-value="value"
                            :label="$t('Currency-Parameter')" autocomplete></v-select>
                           <v-select v-if="PB=='TRY'" :items="tevkifatparametresi" clearable hide-details="" 
                            v-model="SirketParametre.BiletTevkifatIstisnaKodu" item-text="Title" item-value="Ad"
                            :label="$t('Withholding-Exception-Code')" autocomplete></v-select>
                           <parainput v-if="PB=='TRY'" :simge="getparabirimi()"
                             :etiket="$t('Withholding-Minimum-Invoice-Amount')"
                             v-model="SirketParametre.BiletTevkifatFaturaTutari"
                             :autocomplete="'autocomplete'"></parainput>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-tab-item>

            <v-tab href='#1' ripple>
              {{this.$t('Options')}}
            </v-tab>
            <v-tab-item :id="'1'">
              <v-container fluid="">
                <v-layout row="" wrap="">



                  <v-flex xs12 sm6 md4>
                    <v-switch :label="$t('Using-Invoice-Closing')" v-model="SirketParametre.OpsiyonBilgileri.FaturaKapama"
                      value="1"></v-switch>
                  </v-flex>



                  <v-flex xs12 sm6 md4 v-if="PB=='TRY'">
                    <v-switch v-if="PB=='TRY'" :label="$t('Using-E-archive')" v-model="SirketParametre.OpsiyonBilgileri.EArsiv" value="1">
                    </v-switch>
                  </v-flex>

                  <v-flex xs12 sm6 md4 v-if="PB=='TRY'">
                    <v-switch v-if="PB=='TRY'" :label="$t('Standard-E-invoice-System')"
                      v-model="SirketParametre.OpsiyonBilgileri.EFaturaKullaniyor" value="1"></v-switch>
                  </v-flex>

                  <v-flex xs12 sm6 md4 v-if="PB=='TRY'">
                    <v-switch v-if="PB=='TRY'" :label="$t('Special-E-invoice-System')"
                      v-model="SirketParametre.OpsiyonBilgileri.OzelFaturaKullaniyor" value="1"></v-switch>
                  </v-flex>


                  <v-flex xs12 sm6 md4 v-if="PB=='TRY'">
                    <v-switch v-if="PB=='TRY'" :label="$t('Using-E-ledger')" v-model="SirketParametre.OpsiyonBilgileri.EDefter" value="1">
                    </v-switch>
                  </v-flex>

                  <v-flex xs12 sm6 md4>
                    <v-switch :label="$t('Print-Discount')" v-model="SirketParametre.OpsiyonBilgileri.IskontoBas" value="1">
                    </v-switch>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-switch :label="$t('Show-Risk-on-Customer')" v-model="SirketParametre.OpsiyonBilgileri.Risk" value="1" c>
                    </v-switch>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-switch :label="$t('Selling-Currency-VAT-Amount')"
                      v-model="SirketParametre.OpsiyonBilgileri.KdvsizSatis" value="1"></v-switch>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-switch :label="$t('Buying-Currency-on-VAT-Excluded-Amount')" v-model="SirketParametre.OpsiyonBilgileri.KdvsizAlis"
                      value="1"></v-switch>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-switch :label="$t('Synchronize-Sales-Number-with-Ticket')"
                      v-model="SirketParametre.OpsiyonBilgileri.FaturaNoSenkronize" value="1"></v-switch>
                  </v-flex>

                  <v-flex xs12 sm6 md4 v-if="PB=='TRY'">
                    <v-switch v-if="PB=='TRY'" :label="$t('Generate-E-invoice-No-Automatically')"
                      v-model="SirketParametre.OpsiyonBilgileri.OtomatikEFaturaNo" value="1"></v-switch>
                  </v-flex>
                  <v-flex xs12 sm6 md4 v-if="PB=='TRY'">
                    <v-switch v-if="PB=='TRY'" :label="$t('E-invoice-with-Serial-No-with-Zero')"
                      v-model="SirketParametre.OpsiyonBilgileri.EFaturaSifirSerili"></v-switch>
                  </v-flex>


                  <v-flex xs12 sm6 md4 v-if="PB=='TRY'">
                    <!-- v-model YOKTU: switch hicbir alana bagli degildi, bu
                         yuzden yuklemede hep kapali geliyor, isaretlenince
                         yalnizca bilesenin ic durumu degisiyor ve sayfa
                         yenilenince kayboluyordu. -->
                    <v-switch v-if="PB=='TRY'" :label="$t('Print-Details-E-invoice-E-archive')"
                      v-model="SirketParametre.OpsiyonBilgileri.FaturaDetaybas" value="1"></v-switch>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-switch :label="$t('Take-2nd-Row-Invoice-Address2')" value="1"
                      v-model="SirketParametre.Adres2"></v-switch>
                  </v-flex>
                  <v-flex xs12 sm6 md4 v-if="PB=='TRY'">
                    <v-switch v-if="PB=='TRY'" :label="$t('Cancel-Offset-when-Cancelling-Integration')"
                      v-model="SirketParametre.OpsiyonBilgileri.EntMahsup" value="1" ></v-switch>
                  </v-flex>
                    <v-flex xs12 sm6 md4 v-if="PB=='TRY'">
                    <!-- Yol OpsiyonBilgileri ALTINDA: C# tarafinda alan
                         SParamOpsiyon'da. Ust duzeye bagliydi ve Json.NET
                         modelde olmayan alani sessizce yok saydigi icin
                         secenek hic kaydolmuyordu. -->
                    <v-switch v-if="PB=='TRY'" label="Cari Aramayı Uyarı alanından da yap"
                      v-model="SirketParametre.OpsiyonBilgileri.UyariAra"></v-switch>
                  </v-flex>

                  <v-flex xs12 sm6 md4 v-if="PB=='TRY'">
                    <v-switch v-if="PB=='TRY'" label='Serbest e-Faturada "VADE TARIHI" basma'
                      v-model="SirketParametre.OpsiyonBilgileri.SerbestVadeTarihibasma"></v-switch>
                  </v-flex>
                  <v-flex xs12 sm6 md4 v-if="PB=='TRY'">
                    <v-switch v-if="PB=='TRY'" label='Serbest e-Faturada "MERSIS NO" basma'
                      v-model="SirketParametre.OpsiyonBilgileri.SerbestMersisNobasma"></v-switch>
                  </v-flex>



                </v-layout>
              </v-container>
            </v-tab-item>


            <v-tab href='#2' ripple v-if="PB=='TRY'">
              {{$t('Cheque-and-Note')}}
            </v-tab>
            <v-tab-item :id="'2'" style="width:100%; height:100%;">
              <v-flex pa-1 xs12 sm12 md4>
                <v-card>
                  <v-card color="grey lighten-5" flat="">
                    <v-card-actions>
                      <v-layout row="" wrap="">

                        <v-flex xs12 sm12 md12>
                          <v-layout justify-space-between column>
                            <v-text-field hide-details="" v-model="SirketParametre.CekSenetBilgileri.CekAlindiBno"
                              :label="$t('Cheques-Received-Accounting-No')">
                            </v-text-field>
                            <v-text-field hide-details="" v-model="SirketParametre.CekSenetBilgileri.SenetAlindiBNo"
                              :label="$t('Notes-Received-Accounting-No')">
                            </v-text-field>
                            <v-text-field hide-details="" v-model="SirketParametre.CekSenetBilgileri.CekTevdiBno"
                              :label="$t('Company-Cheque-Given-Accounting-No')">
                            </v-text-field>
                            <v-text-field hide-details="" v-model="SirketParametre.CekSenetBilgileri.SenetVHesap"
                              :label="$t('Bill-Account-No-For-Relevant-Company')">
                            </v-text-field>
                          </v-layout>
                        </v-flex>


                      </v-layout>
                    </v-card-actions>
                  </v-card>
                </v-card>
              </v-flex>
            </v-tab-item>

            <v-tab href='#3' ripple v-if="PB=='TRY'">
              Muhasebe
            </v-tab>
            <v-tab-item :id="'3'">
              <v-layout row wrap>
                <v-flex pa-1 xs12 sm6 md6>
                  <v-card>
                    <v-card color="grey lighten-5" flat="">
                      <v-card-actions>
                        <v-flex xs12 sm12 md12>
                          <v-layout justify-space-between column>

                            <v-card flat="" color="#9E9E9E">
                              <v-card-title>
                                <span class="subheading white--text font-weight-medium "> {{$t('Definitions-v2')}}</span>
                              </v-card-title>
                            </v-card>

                            <v-text-field v-model="SirketParametre.MuhasebeBilgileri.AlisKHesap" hide-details=""
                              :label="$t('Discount-Received')">
                            </v-text-field>
                            <v-text-field v-model="SirketParametre.MuhasebeBilgileri.VerisVHesap" hide-details=""
                              :label="$t('Discount-Given')">
                            </v-text-field>
                            <v-text-field v-model="SirketParametre.MuhasebeBilgileri.MuhasebeSirket" hide-details=""
                              :label="$t('Accounting-Company')">
                            </v-text-field>
                            <v-text-field v-model="SirketParametre.MuhasebeBilgileri.KasaHesap" hide-details=""
                              :label="$t('Cash-Accounting-No')">
                            </v-text-field>
                            <v-text-field v-model="SirketParametre.MuhasebeBilgileri.SatisFaturaKdvHesap"
                              hide-details="" :label="$t('Sales-Invoice-Account-VAT-Accounting-No')">
                            </v-text-field>
                            <v-text-field v-model="SirketParametre.MuhasebeBilgileri.AlisFaturaKdvHesap" hide-details=""
                              :label="$t('Buying-Invoice-Disc-VAT-Accounting-No')">
                            </v-text-field>
                            <v-text-field v-model="SirketParametre.MuhasebeBilgileri.SatisIadeKdvHesap" hide-details=""
                              :label="$t('Sales-Refund-VAT-Accounting-Code')">
                            </v-text-field>
                            <v-text-field v-model="SirketParametre.MuhasebeBilgileri.AlisIadeKdvHesap" hide-details=""
                              :label="$t('Buying-Refund-VAT-Accounting-Code')">
                            </v-text-field>
                          </v-layout>
                        </v-flex>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>

                <v-flex pa-1 xs12 sm6 md6>
                  <v-card>
                    <v-card color="grey lighten-5" flat="">
                      <v-card-actions>
                        <v-layout justify-space-between column>

                          <v-card flat="" color="#9E9E9E">
                            <v-card-title>
                              <span class="subheading white--text font-weight-medium "> {{$t('Accounting-Breakdown')}}</span>
                            </v-card-title>
                          </v-card>

                          <v-layout>

                            <v-text-field v-model="SirketParametre.MuhasebeBilgileri.GrupKirilim" hide-details=""
                              :label="$t('Group')"></v-text-field>
                            <v-text-field v-model="SirketParametre.MuhasebeBilgileri.MuavinKirilim" hide-details=""
                              :label="$t('Assistant')">
                            </v-text-field>
                          </v-layout>
                          <v-layout>

                            <v-flex xs12 sm12 md12>
                              <!-- :rules="[(v) => !!v || $t('Mandatory-Areas')]" -->
                  <v-select
                        :items="this.credentialsGenel.MuhasebeSirketler"
                       :item-text="item => item.CompanyShortName +' - '+ '(Firma No: ' +  item.CompanyID + ')'"
                        item-value="CompanyID"
                        label="Muhasebe Firması"
                        v-model="SirketParametre.MuhasebeBilgileri.AccountingCompanyID"
                        :clearable="true"
                        placeholder="Muhasebe Firması Seçin.."
                      ></v-select> 
                </v-flex>
</v-layout>
                        </v-layout>


                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>

              </v-layout>
            </v-tab-item>
          </v-tabs>


        </v-layout>
      </v-card>
    </v-form>
  </sayfataban>
</template>

<script>
  import helpers from "@/components/app/customcomp/helpers.js"
  import parainput from '../customcomp/parainput'
  import sayfataban from "@/components/app/customcomp/sayfataban.vue"
  import kaydetbutonu from "@/components/app/customcomp/kaydetbutonu.vue"
  import tool from "@/components/app/coper/tools"

  export default {
    data() {
      return {
        PB:"TRY",
        credentialsGenel: JSON.parse(window.localStorage.getItem("credentials")),
        SirketParametre: {
          
          SirketKodu: null,
          Adres: '',
          Adres2: '',
          VergiDairesi: '',
          VergiNo: '',
          FaturaSatirAdedi: '',
          KasaDevir: '',
          KapatTarihi: '',
          KapatSifre: '',
          SmsSifre: '',
          SmsKod: '',
          Tel: '',
          Fax: '',
          Email: '',
          Ilce: '',
          Il: '',
          PostaKodu: '',
          CoperSirket: '',
          TicaretSicilNo: '',
          WebAdres: '',
          VarsayilanEfaturaTip: '',
          Dil: '',
          DefaultCurrency: '',
          MersisNo: '',
          SerbestMail: '',
          CekSenetBilgileri: {
            CekPHesap: '',
            CekPKebir: '',
            CekPGrup: '',
            CekPMuavin: '',
            SenetPHesap: '',
            SenetPKebir: '',
            SenetPGrup: '',
            SenetPMuavin: '',
            CekAlindiBno: '',
            CekTevdiBno: '',
            CekNo: '',
            SenetAlindiBNo: '',
            SenetTevdiBNo: '',
            SenetNo: '',
            CekVHesap: '',
            CekVKebir: '',
            CekVGrup: '',
            CekVMuavin: '',
            SenetVHesap: '',
            SenetVKebir: '',
            SenetVGrup: '',
            SenetVMuavin: '',
          },
          MuhasebeBilgileri: {
            AccountingCompanyID:null,
            Muh5aEnt: '',
            GrupKirilim: '',
            MuavinKirilim: '',
            MuhasebeSirket: '',
            KasaHesap: '',
            KasaKebir: '',
            KasaGrup: '',
            KAsaMuavin: '',
            SatisFaturaKdvHesap: '',
            AlisFaturaKdvHesap: '',
            SatisIadeKdvHesap: '',
            AlisIadeKdvHesap: '',
            AlisKHesap: '',
            VerisVHesap: '',
          },
          OpsiyonBilgileri: {
            IskontoBas: '',
            BiletPaket: '',
            Risk: '',
            KdvsizSatis: '',
            KdvsizAlis: '',
            FaturaNoSenkronize: '',
            CoperKullan: '',
            FaturaKapama: '',
            MusteriPersonel: '',
            YolcuCrm: '',
            FaturaMail: '',
            MailOutlook: '',
            Profil: '',
            YeniVersiyonKontrol: '',
            EFaturaKullaniyor: '',
            OzelFaturaKullaniyor: '',
            OtomatikEFaturaNo: '',
            KurParametre: '',
            EntParam: '',
            EntMahsup: '',
            EDefter: '',
            EArsiv: '',
            EFaturaSifirSerili: '',
            FaturaDetaybas: '',
            // C# tarafinda bool; switch'te value prop'u yok, yani true/false
            // uretiyor. Digerleri value="1" ile metin uretiyor.
            UyariAra: false
          },
          BiletTevkifatIstisnaKodu:'',
          // Toplu faturada "Tevkifati Fatura Toplamina Gore Hesapla" secenegi
          // acikken kullanilan esik. Sunucu bos/0 gelirse 12000'e cozuyor.
          BiletTevkifatFaturaTutari: 12000
        },
        tevkifatparametresi:[],
        efaturatipi: [{
            text: this.$t('Commercial'),
            value: '0'
          },
          {
            text: this.$t('Basic'),
            value: '1'
          },
          {
            text: this.$t('Export'),
            value: '2'
          },{
             text: this.$t('Public'),
             value: '3'
          }
        ],

        kurparametresi: [{
            text: this.$t('Buying'),
            value: '0'
          },
          {
            text: this.$t('Sales'),
            value: '1'
          },
          {
            text: this.$t('Effective-Buying'),
            value: '2'
          },
          {
            text: this.$t('Effective-Sales'),
            value: '3'
          }

        ],
        doviztipi: [],

        active: '',

        // Snackbar ve yukleniyor gostergesi TABANDA; sayfa yalnizca bu
        // nesneyi dolduruyor. tool.NewSatatus() -> { show, text, loading }
        durum: tool.NewSatatus(),

        // Yetkisiz gelindiginde taban buraya dondurur. data()'da TANIMLI:
        // eskiden prevRoute hic tanimlanmamisti -- sayfataban'in belgesinde
        // anlatilan tuzagin ta kendisi.
        oncekiRota: null,

        // Save yetkisi. Baslik cubugu slotu kapsamli olmadigi icin tabandan
        // mounted'da okunup buraya yaziliyor.
        kaydetYetkisi: false,

        // CompanyGet basariyla tamamlandi mi. Yalnizca basari dalinda true
        // olur; hata dalinda ve yetki yoksa false kalir.
        parametreYuklendi: false,
      }
    },
    // beforeRouteEnter yalnizca ROTA bileseninde calisir; taban ic ice bir
    // bilesen oldugu icin degeri burada alip prop olarak veriyoruz.
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.oncekiRota = from.path
      })
    },
    components: {
      sayfataban,
      parainput,
      kaydetbutonu
    },
    mounted() {

      // Yetki kontrolu, uyari dialogu ve yonlendirme TABANDA. Taban ic ice
      // bir bilesen oldugu icin onun mounted'i BUNDAN ONCE calisir ve
      // pageScreenAuth senkron; yani yetki burada cozulmus durumda.
      var taban = this.$refs ? this.$refs.taban : null
      this.kaydetYetkisi = taban ? taban.kaydedebilir : false

      // Yetki yoksa hicbir istek atilmamali: taban kullaniciyi zaten
      // gonderiyor, bu arada sunucuya bos yere gidilmesin.
      if (!taban || !taban.sayfayiGorebilir) return

      var credentials = JSON.parse(window.localStorage.getItem('credentials'));
      this.PB=credentials.ParaBirimi
        var paramsTevkifat = {
          CompanyCode: credentials.SirketKodu,
          Type:304
        }
       // Bu iki istegin Promise'i saklaniyor: CompanyGet ikisi de
       // TAMAMLANDIKTAN sonra atilacak (asagida).
       //
       // tool.api_post kullaniliyor: Authorization'in yani sira CariSirketNo /
       // CoperSirketNo / MuhasebeSirketNo basliklarini da gonderiyor. API
       // aktif sirketi YALNIZCA bu basliklardan okuyor (JWT sirket numarasi
       // tasimiyor); duz $http.post ile bu sayfadaki dort istek de sirket
       // bilgisi olmadan gidiyordu. Yol basindaki "api/" onek olarak
       // api_post'un icinde ekleniyor.
       var tevkifatIstegi = tool.api_post(this, 'Definitions/GeneralTypeSearch', paramsTevkifat).then((response) => {
          this.tevkifatparametresi = response.body
        }, (response) => {
          // Iki dal da ayni sabit metni yaziyordu; sunucunun gercek
          // aciklamasi kayboluyordu. HataMesajiCoz baglanti kopmasini
          // (status 0) kendisi ele alip cevrilebilir anahtari donduruyor,
          // bu yuzden ayri dala gerek yok.
          this.durum.text = tool.HataMesajiCoz(response, this.$t.bind(this))
          this.durum.show = true
        })

        var dovizIstegi = tool.api_post(this, 'currency/List', {}).then((response) => {
          this.doviztipi = response.body
        }, (response) => {
          this.durum.text = tool.HataMesajiCoz(response, this.$t.bind(this))
          this.durum.show = true
        })
        this.durum.loading = true

        var params = {
          SirketKodu: credentials.SirketKodu
        }

        // CompanyGet, tevkifat ve doviz listeleri geldikten SONRA atiliyor:
        // SirketParametre'deki degerler bu listelerdeki secenekleri isaret
        // ediyor, liste sonra gelirse secili deger eslesecek ogeyi bulamiyor.
        //
        // Beklenen sey "ikisi de TAMAMLANSIN", "ikisi de BASARILI olsun"
        // degil: bir liste gelmese bile parametreler yuklenmeli, aksi halde
        // tek bir yardimci istek koca ekrani bos birakir. Her istek kendi
        // hata mesajini zaten gosteriyor.
        //
        // .catch bu yuzden var. Bugun iki istegin de .then(basari, hata) cifti
        // hatayi tuketiyor, yani reddetme zaten olusmuyor; ama o incelikli
        // varsayim bozulursa Promise.all reddedilir, CompanyGet HIC atilmaz ve
        // ekran bos kalirdi. allSettled kullanilmiyor: ES2020, bu projenin
        // hedef tarayicilarinda yok.
        Promise.all([tevkifatIstegi, dovizIstegi].map((istek) => {
          return Promise.resolve(istek).catch(() => null)
        })).then(() => {
        tool.api_post(this, 'Parameters/CompanyGet', params).then((response) => {
                  this.durum.loading = false

          // Eksik bolum SESSIZCE TAMAMLANMAZ.
          //
          // Eskiden burada bolum null gelirse data()'daki bos iskelet
          // konuyordu ve parametreYuklendi yine true oluyordu: ekran
          // "yuklendi" gorunuyordu, butun opsiyonlar kapali ciziliyordu ve
          // ilk kayitta 23 sutunun hepsine "" yaziliyordu (govde uretilip
          // olculdu).
          //
          // API bunu ENGELLEYEMEZ: gonderilen nesne null degil, alanlari bos
          // bir nesne; mesru bir "hepsini kapat" isteginden ayirt edilemiyor.
          // Kapinin BURADA olmasi sart.
          //
          // Bolumun eksik gelmesi gercek bir durum: API, sirketin SirketParam
          // satirini bulamazsa alt nesneleri hic doldurmadan donuyor.
          var eksikBolum = this.EksikBolum(response.body)
          if (eksikBolum) {
            this.durum.text = this.$t('Company-parameters-could-not-be-read') + ' (' + eksikBolum + ')'
            this.durum.show = true
            // parametreYuklendi false kaliyor -> kaydet butonu pasif kalir.
            return
          }

          this.ParametreleriYerlestir(response.body)

          // EN SONDA: bayrak "SirketParametre eksiksiz dolu" demek. Yerlestirme
          // patlarsa false kalir ve buton pasif kalir.
          this.parametreYuklendi = true

        }, (response) => {
                  this.durum.loading = false

          // parametreYuklendi false kaliyor: buton pasif kalir.
          //
          // Mesajin kullaniciya ULASMASI sart, yoksa butonun neden pasif
          // oldugu gorulemez. (Eskiden this.text'e yaziliyordu; snackbar
          // baska bir degiskeni gosterdigi icin bombos cikiyordu.)
          this.durum.text = tool.HataMesajiCoz(response, this.$t.bind(this))
          this.durum.show = true
        })
        })
    },

    methods: {
      getparabirimi() {
        return helpers.getparabirimi()
      },

      /**
       * CompanyGet cevabinda eksik gelen ILK alt bolumun ekranda gosterilecek
       * adini dondurur; hepsi doluysa null.
       *
       * API tarafinda ayni kontrol var (SirketParametreSave), ama tek basina
       * YETMIYOR: ekran eksik bolumu kendi iskeletiyle doldurdugunda API artik
       * null gormuyor, alanlari bos dolu bir nesne goruyor.
       */
      /**
       * CompanyGet ya da CompanyAdd'den donen parametre nesnesini ekrana
       * yerlestirir.
       *
       * Iki yol da AYNI son islemleri gerektiriyor (sirket kodu, enum
       * alanlarinin metne cevrilmesi); ayri ayri yazilirsa zamanla ayrisirlar.
       */
      ParametreleriYerlestir(govde) {
        this.SirketParametre = govde
        this.SirketParametre.SirketKodu = this.credentialsGenel.SirketKodu

        // v-select'lerin item-value'lari METIN; sayi gelirse hicbir ogeye
        // eslesmiyor ve secim bos gorunuyor.
        this.SirketParametre.VarsayilanEfaturaTip = String(govde.VarsayilanEfaturaTip)
        if (govde.OpsiyonBilgileri.KurParametre != null) {
          this.SirketParametre.OpsiyonBilgileri.KurParametre = String(govde.OpsiyonBilgileri.KurParametre)
        }
      },

      EksikBolum(govde) {
        if (!govde) { return this.$t('Company') }
        if (govde.OpsiyonBilgileri == null) { return this.$t('Options') }
        if (govde.MuhasebeBilgileri == null) { return this.$t('Accounting') }
        if (govde.CekSenetBilgileri == null) { return this.$t('Cheque-and-Note') }
        return null
      },

      Kaydet: Kaydet
    },
  }

  function Kaydet() {
    if (this.SirketParametre.MuhasebeBilgileri.AccountingCompanyID=='undefined' || this.SirketParametre.MuhasebeBilgileri.AccountingCompanyID==null)
    {
      this.SirketParametre.MuhasebeBilgileri.AccountingCompanyID=0;
    }
    
            var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    this.SirketParametre.SirketKodu= credentials.SirketKodu

    var params = this.SirketParametre
        this.durum.loading = true


    // Promise DONDURULUYOR: kaydetbutonu butonun kilidini bunun cozulmesine
    // gore aciyor.
    return tool.api_post(this, 'Parameters/CompanyAdd', params).then((response) => {
      this.durum.text = this.$t(response.body.ResponseMessage)
      this.durum.show = true
      this.durum.loading = false

      // Ekran artik GONDERDIGIMIZI degil, API'nin kayittan sonra DB'den geri
      // okudugunu gosteriyor. Yazilamayan bir alan (kolon eksik, esleme
      // unutulmus, tip uyusmamis) kayittan hemen sonra ekranda eski degerine
      // donerek kendini belli eder.
      //
      // Status kontrolu sart: API eksik bolumde Status=false ile donuyor ve o
      // durumda SirketParametre gonderilmiyor. Eski surum bir API de bu alani
      // hic gondermez; o zaman ekran oldugu gibi kalir.
      if (response.body.Status === true &&
          response.body.SirketParametre &&
          !this.EksikBolum(response.body.SirketParametre)) {
        this.ParametreleriYerlestir(response.body.SirketParametre)
      }
    }, (response) => {
      // Yukleniyor gostergesi her durumda kapatiliyor. Onceden yalnizca
      // status === 0 dalinda kapatiliyordu; sunucu hatasinda (500, 400 ...)
      // acik kaliyor ve gosterge persistent bir v-dialog oldugu icin ekran
      // tamamen kilitleniyordu -- sayfayi yenilemekten baska care yoktu.
      this.durum.loading = false
      // Iki dal da sabit 'Service Unavailable' yaziyordu; sunucunun gercek
      // aciklamasi kayboluyordu.
      this.durum.text = tool.HataMesajiCoz(response, this.$t.bind(this))
      this.durum.show = true
    })
  }



</script>
<style>
</style>